import trans from '@utils/trans';

export default trans;
